module.exports = __webpack_public_path__ + "static/media/36.0fd38d02.JPG";